/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AppRouteImport } from './routes/_app';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as SignInRouteImport } from './routes/sign-in';
import { Route as SignOutRouteImport } from './routes/sign-out';
import { Route as SsoRouteImport } from './routes/sso';
import { Route as AppAdminRouteImport } from './routes/_app.admin';
import { Route as AppDevelopersRouteImport } from './routes/_app.developers';
import { Route as AppSettingsRouteImport } from './routes/_app.settings';
import { Route as ToolsFireToIrisRouteImport } from './routes/tools.fire-to-iris';
import { Route as AppAdminIndexRouteImport } from './routes/_app.admin.index';
import { Route as AppAdminStaffRouteImport } from './routes/_app.admin.staff';
import { Route as AppAdminUsageRouteImport } from './routes/_app.admin.usage';
import { Route as AppEFilesIndexRouteImport } from './routes/_app.e-files.index';
import { Route as AppEFilesEfileIdRouteImport } from './routes/_app.e-files.$efileId';
import { Route as AppEFilesNewRouteImport } from './routes/_app.e-files.new';
import { Route as AppAdminCustomersCustomerIdRouteImport } from './routes/_app.admin.customers.$customerId';
import { Route as AppEFilesEfileIdCorrectRouteImport } from './routes/_app.e-files.$efileId_.correct';
import { Route as AppEFilesEfileIdReplaceRouteImport } from './routes/_app.e-files.$efileId_.replace';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any);
const SignOutRoute = SignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any);
const SsoRoute = SsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRouteImport,
} as any);
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any);
const AppDevelopersRoute = AppDevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any);
const ToolsFireToIrisRoute = ToolsFireToIrisRouteImport.update({
  id: '/tools/fire-to-iris',
  path: '/tools/fire-to-iris',
  getParentRoute: () => rootRouteImport,
} as any);
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any);
const AppAdminStaffRoute = AppAdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppAdminRoute,
} as any);
const AppAdminUsageRoute = AppAdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AppAdminRoute,
} as any);
const AppEFilesIndexRoute = AppEFilesIndexRouteImport.update({
  id: '/e-files/',
  path: '/e-files/',
  getParentRoute: () => AppRoute,
} as any);
const AppEFilesEfileIdRoute = AppEFilesEfileIdRouteImport.update({
  id: '/e-files/$efileId',
  path: '/e-files/$efileId',
  getParentRoute: () => AppRoute,
} as any);
const AppEFilesNewRoute = AppEFilesNewRouteImport.update({
  id: '/e-files/new',
  path: '/e-files/new',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminCustomersCustomerIdRoute =
  AppAdminCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AppAdminRoute,
  } as any);
const AppEFilesEfileIdCorrectRoute = AppEFilesEfileIdCorrectRouteImport.update({
  id: '/e-files/$efileId_/correct',
  path: '/e-files/$efileId/correct',
  getParentRoute: () => AppRoute,
} as any);
const AppEFilesEfileIdReplaceRoute = AppEFilesEfileIdReplaceRouteImport.update({
  id: '/e-files/$efileId_/replace',
  path: '/e-files/$efileId/replace',
  getParentRoute: () => AppRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in': typeof SignInRoute;
  '/sign-out': typeof SignOutRoute;
  '/sso': typeof SsoRoute;
  '/admin': typeof AppAdminRouteWithChildren;
  '/developers': typeof AppDevelopersRoute;
  '/settings': typeof AppSettingsRoute;
  '/tools/fire-to-iris': typeof ToolsFireToIrisRoute;
  '/admin/staff': typeof AppAdminStaffRoute;
  '/admin/usage': typeof AppAdminUsageRoute;
  '/e-files/$efileId': typeof AppEFilesEfileIdRoute;
  '/e-files/new': typeof AppEFilesNewRoute;
  '/admin/': typeof AppAdminIndexRoute;
  '/e-files/': typeof AppEFilesIndexRoute;
  '/admin/customers/$customerId': typeof AppAdminCustomersCustomerIdRoute;
  '/e-files/$efileId/correct': typeof AppEFilesEfileIdCorrectRoute;
  '/e-files/$efileId/replace': typeof AppEFilesEfileIdReplaceRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in': typeof SignInRoute;
  '/sign-out': typeof SignOutRoute;
  '/sso': typeof SsoRoute;
  '/developers': typeof AppDevelopersRoute;
  '/settings': typeof AppSettingsRoute;
  '/tools/fire-to-iris': typeof ToolsFireToIrisRoute;
  '/admin/staff': typeof AppAdminStaffRoute;
  '/admin/usage': typeof AppAdminUsageRoute;
  '/e-files/$efileId': typeof AppEFilesEfileIdRoute;
  '/e-files/new': typeof AppEFilesNewRoute;
  '/admin': typeof AppAdminIndexRoute;
  '/e-files': typeof AppEFilesIndexRoute;
  '/admin/customers/$customerId': typeof AppAdminCustomersCustomerIdRoute;
  '/e-files/$efileId/correct': typeof AppEFilesEfileIdCorrectRoute;
  '/e-files/$efileId/replace': typeof AppEFilesEfileIdReplaceRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_app': typeof AppRouteWithChildren;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in': typeof SignInRoute;
  '/sign-out': typeof SignOutRoute;
  '/sso': typeof SsoRoute;
  '/_app/admin': typeof AppAdminRouteWithChildren;
  '/_app/developers': typeof AppDevelopersRoute;
  '/_app/settings': typeof AppSettingsRoute;
  '/tools/fire-to-iris': typeof ToolsFireToIrisRoute;
  '/_app/admin/staff': typeof AppAdminStaffRoute;
  '/_app/admin/usage': typeof AppAdminUsageRoute;
  '/_app/e-files/$efileId': typeof AppEFilesEfileIdRoute;
  '/_app/e-files/new': typeof AppEFilesNewRoute;
  '/_app/admin/': typeof AppAdminIndexRoute;
  '/_app/e-files/': typeof AppEFilesIndexRoute;
  '/_app/admin/customers/$customerId': typeof AppAdminCustomersCustomerIdRoute;
  '/_app/e-files/$efileId_/correct': typeof AppEFilesEfileIdCorrectRoute;
  '/_app/e-files/$efileId_/replace': typeof AppEFilesEfileIdReplaceRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sso'
    | '/admin'
    | '/developers'
    | '/settings'
    | '/tools/fire-to-iris'
    | '/admin/staff'
    | '/admin/usage'
    | '/e-files/$efileId'
    | '/e-files/new'
    | '/admin/'
    | '/e-files/'
    | '/admin/customers/$customerId'
    | '/e-files/$efileId/correct'
    | '/e-files/$efileId/replace';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sso'
    | '/developers'
    | '/settings'
    | '/tools/fire-to-iris'
    | '/admin/staff'
    | '/admin/usage'
    | '/e-files/$efileId'
    | '/e-files/new'
    | '/admin'
    | '/e-files'
    | '/admin/customers/$customerId'
    | '/e-files/$efileId/correct'
    | '/e-files/$efileId/replace';
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sso'
    | '/_app/admin'
    | '/_app/developers'
    | '/_app/settings'
    | '/tools/fire-to-iris'
    | '/_app/admin/staff'
    | '/_app/admin/usage'
    | '/_app/e-files/$efileId'
    | '/_app/e-files/new'
    | '/_app/admin/'
    | '/_app/e-files/'
    | '/_app/admin/customers/$customerId'
    | '/_app/e-files/$efileId_/correct'
    | '/_app/e-files/$efileId_/replace';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  SignInRoute: typeof SignInRoute;
  SignOutRoute: typeof SignOutRoute;
  SsoRoute: typeof SsoRoute;
  ToolsFireToIrisRoute: typeof ToolsFireToIrisRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-in': {
      id: '/sign-in';
      path: '/sign-in';
      fullPath: '/sign-in';
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-out': {
      id: '/sign-out';
      path: '/sign-out';
      fullPath: '/sign-out';
      preLoaderRoute: typeof SignOutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sso': {
      id: '/sso';
      path: '/sso';
      fullPath: '/sso';
      preLoaderRoute: typeof SsoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/admin': {
      id: '/_app/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AppAdminRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/developers': {
      id: '/_app/developers';
      path: '/developers';
      fullPath: '/developers';
      preLoaderRoute: typeof AppDevelopersRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/settings': {
      id: '/_app/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AppSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/tools/fire-to-iris': {
      id: '/tools/fire-to-iris';
      path: '/tools/fire-to-iris';
      fullPath: '/tools/fire-to-iris';
      preLoaderRoute: typeof ToolsFireToIrisRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/admin/': {
      id: '/_app/admin/';
      path: '/';
      fullPath: '/admin/';
      preLoaderRoute: typeof AppAdminIndexRouteImport;
      parentRoute: typeof AppAdminRoute;
    };
    '/_app/admin/staff': {
      id: '/_app/admin/staff';
      path: '/staff';
      fullPath: '/admin/staff';
      preLoaderRoute: typeof AppAdminStaffRouteImport;
      parentRoute: typeof AppAdminRoute;
    };
    '/_app/admin/usage': {
      id: '/_app/admin/usage';
      path: '/usage';
      fullPath: '/admin/usage';
      preLoaderRoute: typeof AppAdminUsageRouteImport;
      parentRoute: typeof AppAdminRoute;
    };
    '/_app/e-files/': {
      id: '/_app/e-files/';
      path: '/e-files';
      fullPath: '/e-files/';
      preLoaderRoute: typeof AppEFilesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/e-files/$efileId': {
      id: '/_app/e-files/$efileId';
      path: '/e-files/$efileId';
      fullPath: '/e-files/$efileId';
      preLoaderRoute: typeof AppEFilesEfileIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/e-files/new': {
      id: '/_app/e-files/new';
      path: '/e-files/new';
      fullPath: '/e-files/new';
      preLoaderRoute: typeof AppEFilesNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/customers/$customerId': {
      id: '/_app/admin/customers/$customerId';
      path: '/customers/$customerId';
      fullPath: '/admin/customers/$customerId';
      preLoaderRoute: typeof AppAdminCustomersCustomerIdRouteImport;
      parentRoute: typeof AppAdminRoute;
    };
    '/_app/e-files/$efileId_/correct': {
      id: '/_app/e-files/$efileId_/correct';
      path: '/e-files/$efileId/correct';
      fullPath: '/e-files/$efileId/correct';
      preLoaderRoute: typeof AppEFilesEfileIdCorrectRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/e-files/$efileId_/replace': {
      id: '/_app/e-files/$efileId_/replace';
      path: '/e-files/$efileId/replace';
      fullPath: '/e-files/$efileId/replace';
      preLoaderRoute: typeof AppEFilesEfileIdReplaceRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppAdminRouteChildren {
  AppAdminStaffRoute: typeof AppAdminStaffRoute;
  AppAdminUsageRoute: typeof AppAdminUsageRoute;
  AppAdminIndexRoute: typeof AppAdminIndexRoute;
  AppAdminCustomersCustomerIdRoute: typeof AppAdminCustomersCustomerIdRoute;
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminStaffRoute: AppAdminStaffRoute,
  AppAdminUsageRoute: AppAdminUsageRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminCustomersCustomerIdRoute: AppAdminCustomersCustomerIdRoute,
};

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
);

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren;
  AppDevelopersRoute: typeof AppDevelopersRoute;
  AppSettingsRoute: typeof AppSettingsRoute;
  AppEFilesEfileIdRoute: typeof AppEFilesEfileIdRoute;
  AppEFilesNewRoute: typeof AppEFilesNewRoute;
  AppEFilesIndexRoute: typeof AppEFilesIndexRoute;
  AppEFilesEfileIdCorrectRoute: typeof AppEFilesEfileIdCorrectRoute;
  AppEFilesEfileIdReplaceRoute: typeof AppEFilesEfileIdReplaceRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDevelopersRoute: AppDevelopersRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppEFilesEfileIdRoute: AppEFilesEfileIdRoute,
  AppEFilesNewRoute: AppEFilesNewRoute,
  AppEFilesIndexRoute: AppEFilesIndexRoute,
  AppEFilesEfileIdCorrectRoute: AppEFilesEfileIdCorrectRoute,
  AppEFilesEfileIdReplaceRoute: AppEFilesEfileIdReplaceRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignOutRoute: SignOutRoute,
  SsoRoute: SsoRoute,
  ToolsFireToIrisRoute: ToolsFireToIrisRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
